/* useCountdown — tiny shared helper for HUDs that need a live HH:MM count
 * down to a target ISO timestamp. Updates once per second. */
import { useEffect, useState } from "react";

export function formatCountdown(ms) {
  if (ms <= 0) return "0m 00s";
  const total = Math.floor(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${m.toString().padStart(2, "0")}m`;
  return `${m}m ${s.toString().padStart(2, "0")}s`;
}

export default function useCountdown(targetIso) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);
  if (!targetIso) return { ms: 0, label: "—" };
  const ms = new Date(targetIso).getTime() - now;
  return { ms, label: formatCountdown(ms) };
}
